import auth from "../../middlewares/auth";
export const unitManagementRoute = [
  {
    path: '/unit/registration/list',
    component: () => import(/* webpackChunkName: "unit_management" */ '../../views/unit_management/unit_registration/UnitRegistrationList'),
    name: 'unit_registration_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/unit/registration/add',
    component: () => import(/* webpackChunkName: "unit_management" */ '../../views/unit_management/unit_registration/UnitRegistrationForm'),
    name: 'unit_registration_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/unit/registration/edit/:id',
    component: () => import(/* webpackChunkName: "unit_management" */ '../../views/unit_management/unit_registration/UnitRegistrationForm'),
    name: 'unit_registration_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];